<template>
  <div>
    <ButtonUsers :weet="weet" @click="popUpActive=true" ref="buttonUsers"/>
    <SharePanel v-if="weet" :weet="weet" :active.sync="popUpActive"/>

  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Weet} from '@/store/weet/weetModel';
import SharePanel from '@/components/share/SharePanel.vue';
import ButtonUsers from '@/components/actionButton/ButtonUsers.vue';
import {canEditWorkspace} from '@/utils/workspaceUtil';
import {canEditThisWeet} from '@/utils/weetUtil';
import {informError} from '@/utils/dialog';

@Component({
  components: {SharePanel, ButtonUsers},
})
export default class WeetAudienceButton extends Vue {
  @Prop()
  private weet!: Weet;
  private mustShow: boolean = false;
  private popUpActive: boolean = false;


  public mounted() {
    this.mustShow = true;
  }

  @Watch('popUpActive')
  private refreshUser() {
    if (this.popUpActive) {
      if (canEditWorkspace() && !canEditThisWeet(this.weet, null, false)) {
        informError(this.$t('workspace.manageWeets.doNotAbuse').toString(), 'top');
      }
    } else {
      (this.$refs.buttonUsers as ButtonUsers).loadUsers();
    }
  }


}
</script>

<style scoped lang="scss">

</style>
